import React from "react";
import Helmet from "react-helmet";

export default ({ pageMeta }) => (
    <Helmet>
        <title>{`Pop up | ${pageMeta.title}`}</title>
        <meta name="keywords" content={pageMeta.keywords.join(',')} />
    </Helmet>
)